import { render, staticRenderFns } from "./Enforce2FaPage.vue?vue&type=template&id=5e393b94&scoped=true"
import script from "./Enforce2FaPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./Enforce2FaPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Enforce2FaPage.vue?vue&type=style&index=0&id=5e393b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e393b94",
  null
  
)

export default component.exports